/**
 * @generated SignedSource<<f742126c89b6759fad443a670a66b3b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type loomPersonalization_tenant$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null;
  readonly " $fragmentType": "loomPersonalization_tenant";
};
export type loomPersonalization_tenant$key = {
  readonly " $data"?: loomPersonalization_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_tenant">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "loomPersonalization_tenant"
};

(node as any).hash = "e6f051b771c9dab9394365d5fdc29749";

export default node;
